module.exports = __webpack_public_path__ + "img/Patrick Tsang.d43cf7c1.webp";